// 토스페이먼츠 카드 등록(자동결제) 결제창. 클라이언트 키는 서버가 결제 모드(app_settings.billing)에 맞춰 내려 준다 (test_ck_ / live_ck_)
const SDK_URL = 'https://js.tosspayments.com/v1/payment';

let sdkPromise = null;
function loadSdk() {
    sdkPromise ??= new Promise((resolve, reject) => {
        if (window.TossPayments) return resolve(window.TossPayments);
        const script = document.createElement('script');
        script.src = SDK_URL;
        script.onload = () => resolve(window.TossPayments);
        script.onerror = () => { sdkPromise = null; reject(new Error('결제창을 불러오지 못했어요.')); };
        document.head.appendChild(script);
    });
    return sdkPromise;
}

/**
 * 카드 등록 창을 연다. 성공하면 /billing/success?authKey&customerKey&... 로 돌아온다.
 * mode: 'start'(구독 시작) | 'card'(카드 변경)
 */
export async function requestCardRegistration({ clientKey, userPageId, mode, subscriptionId }) {
    const TossPayments = await loadSdk();
    const customerKey = `shooluk-${crypto.randomUUID()}`;
    const query = new URLSearchParams({ userPageId, mode, ...(subscriptionId ? { subscriptionId } : {}) }).toString();
    return TossPayments(clientKey).requestBillingAuth('카드', {
        customerKey,
        successUrl: `${window.location.origin}/billing/success?${query}`,
        failUrl: `${window.location.origin}/billing/fail?${query}`,
    });
}
